import { useState, useEffect } from "react";

/**
 * A custom hook to trigger a manual refresh at a specified interval.
 * @param {number} seconds - The refresh interval in seconds.
 * @returns {number} - The current timestamp, updated at each interval.
 */
export function useManualRefresh(seconds) {
    const [time, setTime] = useState(Date.now());
    
    const interval = seconds * 1000;

    useEffect(() => {
        const timer = setInterval(() => setTime(Date.now()), interval);

        return () => clearInterval(timer); // Cleanup on unmount
    }, [interval]);

    return time;
}